export enum ModuleTypeEnum {
    CARD_WRITING = 1, // 와글와글
    WORD_CHECK = 2, // 단어 추리하기
    WORD_WRITING = 3, // 받아쓰기
    WORD_SELECTION = 4, // 단어 고르기
    SEED_LETTER = 5, // 씨앗글자
    OX_QUIZ = 6, // OX 퀴즈
    FILL_IN_THE_BLANKS = 7, // 빈칸 채우기
    PRO_CON_DEBATE = 8, // 찬반 토론
    SEGMENTED_READING = 9, // 차근차근 읽기
    SENTENCE_ORDERING = 10, // 순서 맞추기
    CORRECT_THE_MISTAKES = 11, // 고쳐 쓰기\
    POST_IT = 12, // 표 완성하기
}

export const moduleTypeLabel: Record<ModuleTypeEnum, string> = {
    //[ModuleTypeEnum.CARD_WRITING]: '카드작성과 투표',
    [ModuleTypeEnum.CARD_WRITING]: '와글와글 💬️',
    [ModuleTypeEnum.WORD_CHECK]: '단어 추리하기',
    [ModuleTypeEnum.WORD_WRITING]: '받아쓰기',
    [ModuleTypeEnum.WORD_SELECTION]: '단어 고르기',
    [ModuleTypeEnum.SEED_LETTER]: '씨앗글자',
    [ModuleTypeEnum.OX_QUIZ]: 'OX 퀴즈',
    [ModuleTypeEnum.FILL_IN_THE_BLANKS]: '빈칸 채우기',
    [ModuleTypeEnum.PRO_CON_DEBATE]: '찬반 토론',
    [ModuleTypeEnum.SEGMENTED_READING]: '차근차근 읽기',
    [ModuleTypeEnum.SENTENCE_ORDERING]: '순서 맞추기',
    [ModuleTypeEnum.CORRECT_THE_MISTAKES]: '고쳐 쓰기',
    [ModuleTypeEnum.POST_IT]: '표 완성하기',
};

export const moduleTypeThumbnail: Record<ModuleTypeEnum, string> = {
    [ModuleTypeEnum.CARD_WRITING]: 'thumb_card_writing',
    [ModuleTypeEnum.WORD_CHECK]: 'thumb_word_check',
    [ModuleTypeEnum.WORD_WRITING]: 'thumb_word_writing',
    [ModuleTypeEnum.WORD_SELECTION]: 'thumb_word_selection',
    [ModuleTypeEnum.SEED_LETTER]: 'thumb_seed_letter',
    [ModuleTypeEnum.OX_QUIZ]: 'thumb_ox_quiz',
    [ModuleTypeEnum.FILL_IN_THE_BLANKS]: 'thumb_fill_in_the_blanks',
    [ModuleTypeEnum.PRO_CON_DEBATE]: 'thumb_pro_con_debate',
    [ModuleTypeEnum.SEGMENTED_READING]: 'thumb_segmented_reading',
    [ModuleTypeEnum.SENTENCE_ORDERING]: 'thumb_sentence_ordering',
    [ModuleTypeEnum.CORRECT_THE_MISTAKES]: 'thumb_correct_the_mistakes',
    [ModuleTypeEnum.POST_IT]: 'thumb_post_it',
};

export const moduleTypeColor: Record<ModuleTypeEnum, string> = {
    [ModuleTypeEnum.CARD_WRITING]: 'danger',
    [ModuleTypeEnum.WORD_CHECK]: 'primary',
    [ModuleTypeEnum.WORD_WRITING]: 'primary',
    [ModuleTypeEnum.WORD_SELECTION]: 'primary',
    [ModuleTypeEnum.SEED_LETTER]: 'warning',
    [ModuleTypeEnum.OX_QUIZ]: 'info',
    [ModuleTypeEnum.FILL_IN_THE_BLANKS]: 'success',
    [ModuleTypeEnum.PRO_CON_DEBATE]: 'warning',
    [ModuleTypeEnum.SEGMENTED_READING]: 'warning',
    [ModuleTypeEnum.SENTENCE_ORDERING]: 'success',
    [ModuleTypeEnum.CORRECT_THE_MISTAKES]: 'info',
    [ModuleTypeEnum.POST_IT]: 'danger',
};

// 미리보기 구현된 모듈 타입
export const previewModuleTypes = [
    ModuleTypeEnum.CARD_WRITING, // 와글와글
    ModuleTypeEnum.WORD_CHECK, // 단어 추리하기
    ModuleTypeEnum.WORD_WRITING, // 받아쓰기
    ModuleTypeEnum.WORD_SELECTION, // 단어 고르기
    ModuleTypeEnum.SEED_LETTER, // 씨앗글자
    ModuleTypeEnum.CORRECT_THE_MISTAKES, // 고쳐 쓰기
    ModuleTypeEnum.FILL_IN_THE_BLANKS, // 빈칸 채우기
    ModuleTypeEnum.SEGMENTED_READING, // 차근차근 읽기
    ModuleTypeEnum.SENTENCE_ORDERING, // 순서 맞추기
    ModuleTypeEnum.OX_QUIZ, // OX 퀴즈
    ModuleTypeEnum.POST_IT, // 표 완성하기
];

export function getModuleThumbnailPath(type: ModuleTypeEnum): string {
    try {
        return `/assets/img/module/thumb/${moduleTypeThumbnail[type]}.svg`;
    } catch {
        return 'https://placehold.co/480x300';
    }
}
